const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
]

/** ₱12,345 — no decimals, because he never types them. */
export function peso(n) {
  const v = Number(n) || 0
  const sign = v < 0 ? '−' : ''
  return sign + '₱' + Math.abs(Math.round(v)).toLocaleString('en-PH')
}

/** "2026-09" for today, in the browser's timezone. */
export function currentMonthKey(d = new Date()) {
  return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0')
}

/** "2026-09" plus or minus n months. */
export function shiftMonthKey(key, delta) {
  const [y, m] = key.split('-').map(Number)
  const d = new Date(y, m - 1 + delta, 1)
  return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0')
}

/** "2026-09" to "September 2026". */
export function monthName(key) {
  const [y, m] = key.split('-').map(Number)
  return (MONTHS[m - 1] || '') + ' ' + y
}

/** "2026-09" to "SEP '26", for tight chart labels. */
export function shortMonth(key) {
  const [y, m] = key.split('-').map(Number)
  return (MONTHS[m - 1] || '').slice(0, 3).toUpperCase() + " '" + String(y).slice(2)
}

/** "2026-09-15" to "15 Sep". */
export function shortDate(iso) {
  if (!iso) return ''
  const [y, m, d] = String(iso).slice(0, 10).split('-').map(Number)
  if (!y || !m || !d) return String(iso)
  return d + ' ' + (MONTHS[m - 1] || '').slice(0, 3)
}

/** Strips anything that is not a number, so "₱12,000" pastes cleanly. */
export function parseAmount(s) {
  const n = Number(String(s).replace(/[^0-9.-]/g, ''))
  return Number.isFinite(n) ? n : 0
}

/** Today as "2026-09-12". */
export function todayISO(d = new Date()) {
  return (
    d.getFullYear() +
    '-' + String(d.getMonth() + 1).padStart(2, '0') +
    '-' + String(d.getDate()).padStart(2, '0')
  )
}
